import { ConcreteEncodable } from "./ConcreteEncodable";

import { AutoHedgingChangeStateRequestImplEncoder } from "../../encoder/AutoHedgingChangeStateRequestImplEncoder";

import * as CubiqTS from "../../index";
import { AutoHedgingChangeStateRequest } from "../AutoHedgingChangeStateRequest";

export class AutoHedgingChangeStateRequestImpl
  extends ConcreteEncodable
  implements AutoHedgingChangeStateRequest
{
  public static enType: string = "com.bcdfx.model.event.AutoHedgingChangeStateRequestImpl";

  /*FID=1*/
  public autoHedgingEnabled: boolean;
  /*FID=2*/
  public comment: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AutoHedgingChangeStateRequestImplEncoder.Instance;
    this.setEncodableType(AutoHedgingChangeStateRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "AutoHedgingChangeStateRequestImpl[" +
      "autoHedgingEnabled=" +
      this.autoHedgingEnabled +
      "comment=" +
      this.comment +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
